export default "__VITE_PUBLIC_ASSET__7cdf4964__"